import { render } from "./Config.vue?vue&type=template&id=42266fc4"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
script.render = render

export default script